export default "__VITE_ASSET__5df4ae89__"